import { AUTOMATION_CONTEXT_OUTCOME, AUTOMATION_CONTEXT_STEP } from './helper';
import { AUTOMATION_EVENT_TIME_BASED } from './automationEvents';
import {
    AUTOMATION_ACTION_ADD_TAG,
    AUTOMATION_ACTION_SEND_EMAIL_APPLICATION,
    AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS,
    AUTOMATION_ACTION_SET_STEP,
} from './actionForms/constants';

const nonEmptyString = (v) => typeof v === 'string' && v.trim().length > 0;

const conditionValueEmpty = (value) => {
    if (value == null) {
        return true;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }
    return false;
};

const ACTION_VALUE_VALIDATORS = {
    [AUTOMATION_ACTION_ADD_TAG]: (v) => {
        if (!Array.isArray(v.tags) || v.tags.length === 0) {
            return 'Action\'s required fields are missing!';
        }
        return null;
    },
    [AUTOMATION_ACTION_SEND_EMAIL_APPLICATION]: (v) => {
        if (!nonEmptyString(v.subject) || !nonEmptyString(v.message)) {
            return 'Action\'s required fields are missing!';
        }
        return null;
    },
    [AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS]: (v) => {
        if (!nonEmptyString(v.subject) || !nonEmptyString(v.message)) {
            return 'Action\'s required fields are missing!';
        }
        if (!Array.isArray(v.users) || v.users.length === 0) {
            return 'Action\'s required fields are missing!';
        }
        return null;
    },
    [AUTOMATION_ACTION_SET_STEP]: (v) => {
        if (v.step_id == null || v.step_id === '') {
            return 'Action\'s required fields are missing!';
        }
        return null;
    },
};

/**
 * Returns a translation message id for notification, or null if valid.
 */
export function validateRecruitmentAutomationForm({
    category,
    contextId,
    event,
    cron,
    groups,
    selectedAction,
    actionValue,
}) {
    if (!event) {
        return 'Please select the trigger';
    }

    if (event === AUTOMATION_EVENT_TIME_BASED) {
        if (!Array.isArray(cron) || cron.length === 0) {
            return 'Please select the schedule';
        }
    }

    if (category === AUTOMATION_CONTEXT_STEP && (contextId == null || contextId === '')) {
        return 'Invalid step';
    }
    if (category === AUTOMATION_CONTEXT_OUTCOME && (contextId == null || Number.isNaN(Number(contextId)))) {
        return 'Invalid outcome';
    }

    const groupList = Array.isArray(groups) ? groups : [];
    for (const group of groupList) {
        const conditions = Array.isArray(group?.conditions) ? group.conditions : [];
        if (conditions.length === 0) {
            return 'Conditions are required';
        }
        const signatures = [];
        for (const row of conditions) {
            if (!row?.filter || conditionValueEmpty(row.value)) {
                return 'Conditions are required';
            }
            signatures.push(JSON.stringify([row.filter, row.value]));
        }
        if (new Set(signatures).size !== signatures.length) {
            return 'Duplicate conditions are not allowed';
        }
    }

    if (!selectedAction?.id) {
        return 'Action is required';
    }

    const id = selectedAction.id;
    const v = actionValue && typeof actionValue === 'object' ? actionValue : {};
    const validateActionValue = ACTION_VALUE_VALIDATORS[id];
    if (validateActionValue) {
        return validateActionValue(v);
    }

    return null;
}
